import { readonly, reactive, ref } from 'vue'
import log from '../logger/log.js';

class API
{
    constructor()
    {
        this.auth = null;
        this.url = null;
    }

    set_auth(auth)
    {
        this.auth = auth;
    }

    set_url(url)
    {
        this.url = url.replace(/\/+$/g, '');
    }

    gen_action_id()
    {
        return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    }

    gen_action(action)
    {
        var obj = {};
        obj.action = '';
        obj.action_id = '';
        if (action !== null && action !== undefined)
        {
            obj.action = action;
        }
        obj.action_id = this.gen_action_id();
        obj.is_action = true;
        return obj;
    }

    async get(path, req_data)
    {   
        try
        {
            let headers = {};
            if(!req_data)
            {
                req_data = {};
            }
            if ("taxi_token" in this.auth)
            {
                req_data.token = this.auth.taxi_token;
            } else if ("dispatcher_token" in this.auth)
            {
                req_data.auth = {token: this.auth.dispatcher_token};
            } else if ("token" in this.auth)
            {
                req_data.token = this.auth.token;
            }
            else if ("client_token" in this.auth) {
                req_data.auth = this.auth.client_token;
                req_data.lang = 'pl';
            }
            else if ("hq_token" in this.auth) {
                headers.Authorization = `Bearer ${this.auth.hq_token}`;
            }
            let req_json = null; 
            if ("client_token" in this.auth || req_data.is_action) {
                const body = new URLSearchParams(); 
                body.append('cmd', JSON.stringify(req_data));
                req_json = body;
            }
            else {
                req_json = JSON.stringify(req_data);
            }
            let credentials = ("hq" in this.auth) ? 'include' : 'same-origin';
            //log.d("auth", this.auth);
            //log.d("req_json", req_json);
            let response = await fetch(this.url + path, 
                {method: 'POST', body: req_json, headers: headers, credentials: credentials }
            );
/*
            if(!response.ok)
            {
                return {"error": true, "error_data": "CONNECTION_ERROR"}
            }
*/
            let resp_data = await response.json();
            if(resp_data?.status === "ERR")
            {
                return {"error": true, "error_data": resp_data?.status_mesg || 'CONNECTION_ERROR'}
            }
            //log.d(resp_data);
            return resp_data;
        } catch (e)
        {
            log.d(e);
            return null;
        }
    }

    is_resp_error(resp)
    {
        return !resp || !resp.error;
    }

}

const api = new API();
const useAPI = function()
{
  return { api };
}

export {useAPI};
